import { createSvgIconComponent } from "../utils";

export const IconDownArrow = createSvgIconComponent({
  path: "M 0,0 V 2.1462796 L 4.3219228,5 8.5714286,2.1462796 V 0 L 4.3219228,2.5 Z",
  viewBox: "0 0 9 5",
});
